"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AccessControlTranslation = {
    type: "structure",
    required: ["Owner"],
    members: {
        Owner: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_AccessControlTranslation.js.map